import React from 'react';
import PropTypes from 'prop-types';
import { Form, Col, Row } from 'react-bootstrap';
import Select from 'react-select';
import { useDarkMode } from 'Hooks';
import { getReactSelectStyles } from 'Helpers/UiHelper';

const TravelTypeSection = ({
  currentSelectedFlight,
  setCurrentSelectedFlight,
  validationFlightFormErrors,
  setValidationFlightFormErrors,
  mappedTravelTypes,
  mappedPaymentMethods,
  isDisabled,
}) => {
  const { darkMode } = useDarkMode();

  return (
    <Row>
      <Form.Group as={Col}>
        <Form.Label>Travel Type</Form.Label>
        <Select
          isDisabled={isDisabled}
          options={mappedTravelTypes}
          isSearchable
          isClearable
          value={mappedTravelTypes.find((x) => x.value === currentSelectedFlight.travelType)}
          onChange={(e) => {
            setValidationFlightFormErrors({});
            setCurrentSelectedFlight({
              ...currentSelectedFlight,
              travelType: e?.value || '',
            });
          }}
          styles={getReactSelectStyles(darkMode)}
        />
        {validationFlightFormErrors.travelType && (
          <Form.Control.Feedback type="invalid" style={{ display: 'block' }}>
            {validationFlightFormErrors.travelType}
          </Form.Control.Feedback>
        )}
      </Form.Group>
      <Form.Group as={Col}>
        <Form.Label>Payment Method</Form.Label>
        <Select
          isDisabled={isDisabled}
          options={mappedPaymentMethods}
          isSearchable
          isClearable
          value={mappedPaymentMethods.find((x) => x.value === currentSelectedFlight.paymentMethod)}
          onChange={(e) => {
            setValidationFlightFormErrors({});
            setCurrentSelectedFlight({
              ...currentSelectedFlight,
              paymentMethod: e?.value || '',
            });
          }}
          styles={getReactSelectStyles(darkMode)}
        />
        {validationFlightFormErrors.paymentMethod && (
          <Form.Control.Feedback type="invalid" style={{ display: 'block' }}>
            {validationFlightFormErrors.paymentMethod}
          </Form.Control.Feedback>
        )}
      </Form.Group>
    </Row>
  );
};

TravelTypeSection.propTypes = {
  currentSelectedFlight: PropTypes.object.isRequired,
  setCurrentSelectedFlight: PropTypes.func.isRequired,
  validationFlightFormErrors: PropTypes.object.isRequired,
  setValidationFlightFormErrors: PropTypes.func.isRequired,
  mappedTravelTypes: PropTypes.array.isRequired,
  mappedPaymentMethods: PropTypes.array.isRequired,
  isDisabled: PropTypes.bool.isRequired,
};

export default TravelTypeSection;
